import { LifeCycleStatusVoData } from "../../vo/lifecycle-status/life-cycle-status-vo-data";
var LifeCycleConverters = /** @class */ (function () {
    function LifeCycleConverters() {
    }
    LifeCycleConverters.convertToLifeCycleStatusVoDataArray = function (lifeCycleStatusApiDataArray) {
        var lcsVoDataArray = new Array();
        for (var _i = 0, lifeCycleStatusApiDataArray_1 = lifeCycleStatusApiDataArray; _i < lifeCycleStatusApiDataArray_1.length; _i++) {
            var lcsApiData = lifeCycleStatusApiDataArray_1[_i];
            lcsVoDataArray.push(this.convertToLifeCycleStatusVoData(lcsApiData));
        }
        return lcsVoDataArray;
    };
    LifeCycleConverters.convertToLifeCycleStatusVoData = function (lifeCycleStatusApiData) {
        var lcsVoData = new LifeCycleStatusVoData(lifeCycleStatusApiData.name);
        lcsVoData.appliedProperty = lifeCycleStatusApiData.appliedProperty;
        lcsVoData.iconColor = lifeCycleStatusApiData.iconColor;
        lcsVoData.iconStyleName = lifeCycleStatusApiData.iconStyleName;
        return lcsVoData;
    };
    return LifeCycleConverters;
}());
export { LifeCycleConverters };
//# sourceMappingURL=life-cycle-converters.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/life-cycle-converters.js
// module id = 970
// module chunks = 14